<section id="schedule" class="content consulta bgGreen">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3 class="title"><span>Faça seu pré-agendamento</span></h3>
                <div class="form">
                    <form [formGroup]="scheduleForm" (ngSubmit)="onSendMessage(scheduleForm.value)">
                        <div class="form-group">
                            <input type="text" class="form-control" id="name" placeholder="Nome" formControlName="name"
                                maxlength="45" />
                            <div *ngIf="invalidForm && scheduleForm.controls['name'].invalid" class="text-danger">
                                Preencha seu nome.
                            </div>
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-control" id="email" placeholder="E-mail"
                                formControlName="email" maxlength="60" />
                            <div *ngIf="invalidForm && scheduleForm.controls['email'].invalid" class="text-danger">
                                E-mail inválido.
                            </div>
                        </div>
                        <div class=" form-group">
                            <input type="text" class="form-control" id="phone" placeholder="Telefone"
                                formControlName="phone" maxlength="15" [imask]="{mask: '(00) 00000000[0]'}" />
                            <div *ngIf="invalidForm && scheduleForm.controls['phone'].invalid" class="text-danger">
                                Preencha seu telefone.
                            </div>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control" id="message" rows="5" placeholder="Mensagem"
                                formControlName="message" maxlength="250"></textarea>
                        </div>
                        <button type="submit" class="btn btn-white"><i class="bi bi-whatsapp"></i> Solicitar
                            agendamento</button>
                        <div [ngClass]="setAlertClass()">{{messageResult}}</div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>